import React from "react";
import { useTranslation } from "react-i18next";

import FileUploadCard from "../FileUploadCard";
import FileSelectionCard from "../FileUploadCard/FileSelectionCard";

import { FileExclamationIcon } from "../../assets/icons";
import { waveProLogo } from "../../assets/images";

const SUPPORTED_IMPORT_FILE_TYPES = ["DWPX", "DWPRO"];
const IMPORT_FILE_MAX_SIZE_MB = 10;

const FileSelectAndExtract = ({ onExtract }) => {
  const { t } = useTranslation();

  const [selectedFile, setSelectedFile] = React.useState(null);
  const handleFileSelection = (file) => {
    if (file) {
      setSelectedFile(file);
    }
  };

  return (
    <>
      {selectedFile ? (
        <FileUploadCard
          uploadedFile={selectedFile}
          setUploadedFile={setSelectedFile}
          onValidHandler={() => onExtract(selectedFile)}
          primaryActionLabel={"importPlantWavePro.import"}
          isUploadComplete={false}
          fileImg={waveProLogo}
          supportedFileTypes={SUPPORTED_IMPORT_FILE_TYPES}
          maxFileSize={`${IMPORT_FILE_MAX_SIZE_MB}MB`}
          successMessage={t("importPlantWavePro.extractSuccessMessage")}
          hideReplaceOnSuccess={true}
        />
      ) : (
        <FileSelectionCard
          id="import-plant-upload-zone"
          hoverable
          setUploadedFile={handleFileSelection}
          supportedFileTypes={SUPPORTED_IMPORT_FILE_TYPES}
          maxFileSize={`${IMPORT_FILE_MAX_SIZE_MB}MB`}
          size="115px"
        />
      )}
      <div className="import-plant-config-guidance">
        <div className="import-plant-config-guidance-title">
          <FileExclamationIcon />
          {t("importPlantWavePro.guidanceTitle")}
        </div>
        <ul>
          <li>{t("importPlantWavePro.guidancePoint1")}</li>
          <li>{t("importPlantWavePro.guidancePoint2")}</li>
          <li>{t("importPlantWavePro.guidancePoint3")}</li>
        </ul>
      </div>
    </>
  );
};

export default FileSelectAndExtract;
